module.exports = __webpack_public_path__ + "img/fms.4119349f.png";